import styled from "styled-components";

const SidebarWrap = styled.div``;

export default SidebarWrap;